var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeyondCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 60,
    height: 60,
    rx: 11,
    transform: "translate(1211 702)",
    fill: "#5d44ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 77.085,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M4.243,7.019V8.6L4.8,8.249V6.979L6.24,5.3,2.85,5.294Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.841,
    y1: 16.527,
    x2: -0.546,
    y2: 16.527,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcf31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 60,
    height: 60,
    rx: 3.46,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 13.611,
    height: 0.567,
    transform: "translate(17.254 18.671)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 8.79,
    height: 0.567,
    transform: "translate(17.254 19.664)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 13.611,
    height: 0.567,
    transform: "translate(47.453 50.997)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 8.79,
    height: 0.567,
    transform: "translate(47.453 51.99)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 13.611,
    height: 0.567,
    transform: "translate(39.23 33.7)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 8.79,
    height: 0.567,
    transform: "translate(39.23 34.692)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 13.611,
    height: 0.567,
    transform: "translate(57.803 27.32)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(-510 -702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    transform: "translate(-701)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(1211 702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M56.54,60H3.461A3.46,3.46,0,0,1,0,56.54V3.46A3.46,3.46,0,0,1,3.461,0H56.54A3.46,3.46,0,0,1,60,3.46V56.54A3.46,3.46,0,0,1,56.54,60",
    fill: "#5d44ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M2,8.429H1.993l-.028.121H1.7V7.029l.335-.077v.39l-.008.174a.457.457,0,0,1,.3-.125c.274,0,.444.226.444.573,0,.39-.231.613-.476.613A.412.412,0,0,1,2,8.429m.428-.459c0-.2-.063-.3-.2-.3a.257.257,0,0,0-.194.1v.464a.269.269,0,0,0,.18.072c.117,0,.211-.1.211-.333",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M2.945,7.984a.556.556,0,0,1,.533-.593.477.477,0,0,1,.482.543.722.722,0,0,1-.014.148H3.27a.272.272,0,0,0,.293.239.472.472,0,0,0,.245-.074l.111.2a.733.733,0,0,1-.4.128.552.552,0,0,1-.572-.593m.729-.124c0-.124-.054-.214-.188-.214a.224.224,0,0,0-.22.214Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M5.04,7.984a.553.553,0,1,1,.551.593.556.556,0,0,1-.551-.593m.759,0c0-.2-.069-.323-.208-.323s-.207.127-.207.323.069.322.207.322S5.8,8.18,5.8,7.984",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M6.372,7.418h.274l.024.143h.008a.519.519,0,0,1,.364-.17c.246,0,.351.173.351.456v.7H7.057V7.89c0-.163-.043-.214-.14-.214a.289.289,0,0,0-.21.11V8.55H6.372Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M7.619,7.984a.529.529,0,0,1,.47-.593.374.374,0,0,1,.277.117l-.012-.171V7.028l.335-.077v1.6H8.416l-.024-.112H8.383a.449.449,0,0,1-.3.14c-.281,0-.463-.224-.463-.593m.735.217V7.736a.274.274,0,0,0-.187-.071c-.109,0-.2.1-.2.315s.077.322.206.322a.217.217,0,0,0,.185-.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M3.525,9.931V8.746h.319v1.2c0,.068.032.09.058.09a.154.154,0,0,0,.039,0l.038.235a.42.42,0,0,1-.16.026c-.219,0-.294-.142-.294-.36",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M4.116,9.727a.53.53,0,0,1,.508-.565.454.454,0,0,1,.458.517.74.74,0,0,1-.013.141H4.425a.26.26,0,0,0,.279.228.446.446,0,0,0,.233-.071l.106.192a.7.7,0,0,1-.382.122.525.525,0,0,1-.545-.564m.694-.118c0-.118-.051-.2-.179-.2a.212.212,0,0,0-.209.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M5.317,9.966c0-.227.18-.349.606-.394a.15.15,0,0,0-.17-.156.594.594,0,0,0-.285.1L5.355,9.3a.881.881,0,0,1,.459-.142c.275,0,.428.158.428.487v.616h-.26l-.023-.111H5.951a.472.472,0,0,1-.313.137.31.31,0,0,1-.321-.325m.606-.014V9.764c-.227.031-.3.1-.3.177s.048.1.124.1a.244.244,0,0,0,.177-.092",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M6.444,9.728a.505.505,0,0,1,.447-.566.353.353,0,0,1,.263.113l-.011-.164V8.823l.319-.078v1.519H7.2l-.023-.1H7.171a.427.427,0,0,1-.286.132c-.268,0-.441-.213-.441-.563m.7.2V9.492a.263.263,0,0,0-.178-.068c-.1,0-.194.1-.194.3s.073.306.2.306a.2.2,0,0,0,.175-.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M7.771,10.094l.452-.655h-.4V9.188h.8v.171l-.452.655h.466v.251H7.771Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M4.242,8.682a.059.059,0,0,1-.033-.011A.084.084,0,0,1,4.178,8.6V7.045l-1.389-1.7a.077.077,0,0,1-.008-.081.075.075,0,0,1,.069-.043l3.39.008a.08.08,0,0,1,.069.045.075.075,0,0,1-.01.081L4.862,7.007V8.25a.082.082,0,0,1-.034.069l-.557.354a.052.052,0,0,1-.029.009",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 3.39,
    height: 3.31,
    transform: "translate(2.85 5.294)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M74.954,58.086H12.439a2.131,2.131,0,0,1-2.132-2.132V6.625a2.131,2.131,0,0,1,2.132-2.132H74.954a2.131,2.131,0,0,1,2.131,2.132v49.33a2.131,2.131,0,0,1-2.131,2.131",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 60.115,
    height: 40.833,
    transform: "translate(13.567 14.701)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 40.833,
    transform: "translate(21.862 14.631)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 40.833,
    transform: "translate(30.652 14.701)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y2: 40.833,
    transform: "translate(39.301 14.631)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y2: 40.833,
    transform: "translate(48.091 14.701)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 40.833,
    transform: "translate(56.314 14.631)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 60.115,
    transform: "translate(13.639 23.137)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 60.115,
    transform: "translate(13.709 31.219)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 60.115,
    transform: "translate(13.639 39.3)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 60.115,
    transform: "translate(13.709 47.382)",
    fill: "none",
    stroke: "#939393",
    strokeWidth: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M14.915,8.321a.638.638,0,1,1-.639-.638.639.639,0,0,1,.639.638",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M17.254,8.392a.638.638,0,1,1-.638-.638.638.638,0,0,1,.638.638",
    fill: "#fdeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M19.664,8.392a.638.638,0,1,1-.638-.638.638.638,0,0,1,.638.638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M56.232,45.468H43.778a2,2,0,0,1-2-2V42.5a2,2,0,0,1,2-2H56.232a2,2,0,0,1,2,2v.97a2,2,0,0,1-2,2",
    fill: "#eff5fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M27.084,29.021H20.042a1.655,1.655,0,0,1-1.654-1.654v-.8a1.655,1.655,0,0,1,1.654-1.655h7.042a1.654,1.654,0,0,1,1.654,1.655v.8a1.654,1.654,0,0,1-1.654,1.654"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M30.428,21.79H17.974a2,2,0,0,1-2-2v-.97a2,2,0,0,1,2-2H30.428a2,2,0,0,1,2,2v.97a2,2,0,0,1-2,2",
    fill: "#dfd1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M30.637,18.246H17.482a.229.229,0,0,1-.228-.228v-.111a.229.229,0,0,1,.228-.228H30.637a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M30.637,19.238H17.482a.229.229,0,0,1-.228-.228V18.9a.229.229,0,0,1,.228-.228H30.637a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M25.816,20.231H17.482A.229.229,0,0,1,17.254,20v-.111a.229.229,0,0,1,.228-.228h8.334a.229.229,0,0,1,.228.228V20a.229.229,0,0,1-.228.228",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M60.485,53.407H48.031a2,2,0,0,1-2-2v-.97a2,2,0,0,1,2-2H60.485a2,2,0,0,1,2,2v.969a2,2,0,0,1-2,2",
    fill: "#fdeaea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M60.836,51.564H47.681a.229.229,0,0,1-.228-.228v-.111A.229.229,0,0,1,47.681,51H60.836a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M56.015,52.557H47.681a.229.229,0,0,1-.228-.228v-.111a.229.229,0,0,1,.228-.228h8.334a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M55.732,50.146H47.681a.229.229,0,0,1-.228-.228v-.111a.229.229,0,0,1,.228-.228h8.051a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M51.553,36.252H39.1a2,2,0,0,1-2-2v-.97a2,2,0,0,1,2-2H51.553a2,2,0,0,1,2,2v.97a2,2,0,0,1-2,2",
    fill: "#eff5fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M52.612,34.267H39.457a.229.229,0,0,1-.228-.228v-.111a.229.229,0,0,1,.228-.228H52.612a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M47.792,35.26H39.458a.229.229,0,0,1-.228-.228v-.111a.229.229,0,0,1,.228-.228h8.334a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M47.508,32.849H39.457a.229.229,0,0,1-.228-.228V32.51a.229.229,0,0,1,.229-.228h8.05a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M72,28.454H58.065A1.255,1.255,0,0,1,56.81,27.2V26.59a1.255,1.255,0,0,1,1.255-1.255H72a1.255,1.255,0,0,1,1.255,1.255V27.2A1.255,1.255,0,0,1,72,28.454"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M71.186,27.887H58.031a.229.229,0,0,1-.228-.228v-.111a.229.229,0,0,1,.228-.228H71.186a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M66.082,26.611H58.031a.229.229,0,0,1-.228-.228v-.111a.229.229,0,0,1,.228-.228h8.051a.229.229,0,0,1,.228.228v.111a.229.229,0,0,1-.228.228",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M17.836,38.662H16.673a2.4,2.4,0,0,1-2.4-2.4V35.1a2.4,2.4,0,0,1,2.4-2.4h1.163a2.4,2.4,0,0,1,2.4,2.4v1.163a2.4,2.4,0,0,1-2.4,2.4",
    fill: "#dfd1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M17.821,35.827a1.134,1.134,0,1,1-1.134-1.134,1.134,1.134,0,0,1,1.134,1.134",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M60.795,22.216H59.631a2.4,2.4,0,0,1-2.4-2.4V18.657a2.4,2.4,0,0,1,2.4-2.4h1.164a2.4,2.4,0,0,1,2.4,2.4V19.82a2.4,2.4,0,0,1-2.4,2.4",
    fill: "#eff5fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M59.646,18.175a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M35.133,56.952H33.97a2.4,2.4,0,0,1-2.4-2.4V53.393a2.4,2.4,0,0,1,2.4-2.4h1.164a2.4,2.4,0,0,1,2.4,2.4v1.163a2.4,2.4,0,0,1-2.4,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M35.827,55.6a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M35.4,53.549a.993.993,0,1,1-.992-.992.992.992,0,0,1,.992.992",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M73.186,9.03H54.471a.638.638,0,1,1,0-1.276H73.186a.638.638,0,1,1,0,1.276"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondCalender);
export default __webpack_public_path__ + "static/media/beyondCalender.e1b15935a1ca5f3770a7162926114921.svg";
export { ForwardRef as ReactComponent };